<template>
  <div class="lztAboutPage">
    <div class="lztJpg">
      <img :src="baseUrl+'lztAbout.png'" alt />
      <div class="jumpBtn" v-if="userinfo.appId!='zhenjiangqu'">
        <a href="javascript:void(0);" @click="Jump(1)">
          <img :src="baseUrl+'jumpDh.png'" alt />
        </a>
        <a href="javascript:void(0);" @click="Jump(2)">
          <img :src="baseUrl+'jumpZnsty.png'" alt />
        </a>
      </div>
      <!-- 浈江区用这个 -->
      <div class="jumpBtn" v-else>
        <a href="javascript:void(0);">
          <img :src="baseUrl+'jumpZnstyZJ.png'" alt />
        </a>
        <a href="javascript:void(0);">
          <img :src="baseUrl+'jumpDhZJ.png'" alt />
        </a>
      </div>
      <p class="lztAboutText" v-if="userinfo.appId=='zhenjiangqu'">投诉电话：0751-8932629（本平台为互联网非涉密平台，严禁处理、传输国家机密）</p>
    </div>
  </div>
</template>
<script>
/*eslint-disable*/
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
import { mapState } from 'vuex'
export default {
  name: "lztAbout",
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      userToken: "",
      clientType: "" //手机类型
    };
  },
  mounted() {
    this.clientType = getDeviceType();
    this.userToken = this.$route.query.token;
    console.log('appId='+this.userinfo,this.userinfo.appId)
  },
  methods: {
    Jump(type) {
      let jumpUrl = window.location.protocol + "//" + window.location.host + "";
      let timestamp = Date.parse(new Date());
      if (type == "1") {
        if (this.clientType == "android") {
          window.android.getInfo(
            105,
            "" + jumpUrl + "/dhome-lzz-lzt-h5/#/lztDh?commonId="
          );
        } else {
          //IOS
          window.webkit.messageHandlers.getJumpUrl.postMessage(
            "" +
              jumpUrl +
              "/dhome-lzz-lzt-h5/#/lztDh?commonId=&token=" +
              this.userToken +
              "&time=" +
              timestamp +
              ""
          );
        }
      } else {
        if (this.clientType == "android") {
          window.android.getInfo(
            105,
            "" + jumpUrl + "/dhome-lzz-lzt-h5/#/lztZnsty?commonId="
          );
        } else {
          //IOS
          window.webkit.messageHandlers.getJumpUrl.postMessage(
            "" +
              jumpUrl +
              "/dhome-lzz-lzt-h5/#/lztZnsty?commonId=&token=" +
              this.userToken +
              "&time=" +
              timestamp +
              ""
          );
        }
      }
    }
  },
  computed: {
      ...mapState(['userinfo'])
  },
};
</script>
<style lang="less">
.lztAboutPage {
  width: 100%;
  height: 100%;
  .lztJpg {
    position: relative;
    img {
      width: 100%;
      min-height: 100%;
    }
    .jumpBtn {
      position: absolute;
      bottom: 90px;
      left: 50%;
      margin-left: -78px;
      a {
        display: block;
        width: 155px;
        height: 45px;
        margin: 10px 0;
        img {
          width: 100%;
          min-height: 100%;
        }
      }
    }
    .lztAboutText{
      position: absolute;
      bottom: 0px;
      left: 0;
      padding: 10px;
      color: #fff;
      width: 100%;
      font-size: 11px;
      text-align: center;
    }

  }
}
</style>